export const BLOCK_STORE_NAME = 'Blocks'
